let {
  getBrands
} = require('./brands'); // Handle nav for various markets and include nav options for other links


let getSpecialNav = function getSpecialNav(meta, urlAdd, forceColor, navLink, navArray) {
  // If we aren't passing meta in, we have to call getSettings here
  if (!meta) {
    let {
      getSettings
    } = require('./settings');

    meta = getSettings();
  } // If a link object was not provided, make one


  if (!navLink) {
    navLink = {
      url: "#___gatsby",
      text: "Special Report",
      target: "_self"
    };
  } // If a navArray was provided, create the subnav


  let subnav = "";
  let dropdownIcon = "";

  if (navArray && navArray.length > 0) {
    subnav = "<ul id=\"subnav\">";

    for (let i = 0; i < navArray.length; i++) {
      subnav += "<li><a class=\"active\" href=\"".concat(navArray[i].url, "\" target=\"").concat(navArray[i].target, "\"><span class=\"arrow-bullet\">\u25B6</span> ").concat(navArray[i].text, "</a></li>");
    }

    subnav += "</ul>"; // Add a dropdown icon

    dropdownIcon = "<div class=\"dropdown-icon\">\u25BE</div>";
  } // Extension to URL if passed in


  if (!urlAdd) {
    urlAdd = "";
  }

  let {
    attributes: {
      marketPrefix,
      invert,
      subscribeLink
    }
  } = getBrands(meta.PROJECT.MARKET_KEY); // Handle various CT domains

  if (typeof window !== "undefined") {
    switch (window.location.origin) {
      case "https://www.ctpost.com":
        marketPrefix = "ct";
        break;

      case "https://www.nhregister.com":
        marketPrefix = "nh";
        break;

      case "https://www.greenwichtime.com":
        marketPrefix = "gt";
        break;

      case "https://www.stamfordadvocate.com":
        marketPrefix = "st";
        break;

      case "https://www.thehour.com":
        marketPrefix = "th";
        break;

      case "https://www.newstimes.com":
        marketPrefix = "nt";
        break;

      case "https://www.middletownpress.com":
        marketPrefix = "mp";
        break;

      case "https://www.ctinsider.com":
        marketPrefix = "in";
        break;
    }
  } // Default is white text on black nav (SFC style)


  let invertClass = "";
  let color = "white"; // If inverted, do black on white nav
  // Only change things if color isn't forced to white

  if (invert || forceColor === "white") {
    invertClass = "invert";
    color = "black";
  }

  let subfolder = "";

  if (meta.PROJECT.SUBFOLDER) {
    subfolder = meta.PROJECT.SUBFOLDER + "/";
  }

  const getLinkHtml = prefix => {
    let htmlBlock = "<a class=\"special-nav-subscribe-link\" href=".concat(subscribeLink, " target=\"_blank\">\n\t\t<p>Subscribe</p>\n\t\t</a>");

    if (prefix == "ct") {
      htmlBlock += "<a class=\"special-nav-newsletter-link\" href=\"https://link.ctpost.com/join/signup-po\" target=\"_blank\">\n\t\t\t<p>Newsletters</p>\n\t\t\t</a>";
    } else if (prefix == "sf") {
      htmlBlock += "<a class=\"special-nav-newsletter-link\" href=\"https://link.sfchronicle.com/join/signup\" target=\"_blank\">\n\t\t\t<p>Newsletters</p>\n\t\t\t</a>";
    } else if (prefix == "hc") {
      htmlBlock += "<a class=\"special-nav-newsletter-link\" href=\"https://link.houstonchronicle.com/join/signup-hc\" target=\"_blank\">\n\t\t\t<p>Newsletters</p>\n\t\t\t</a>";
    }

    return htmlBlock;
  };

  let navRightHtml = getLinkHtml(marketPrefix);
  let navHTML = "<nav class=\"topper-special-nav-container ".concat(invertClass, "\">\n\t<div class=\"special-nav-left\">\n\t<a class=\"special-nav-back\" \n\thref=\"/\"\n\ttarget=\"_blank\"\n\trel=\"noopener noreferrer\">\n\t\t<svg class=\"special-nav-carrot\" version=\"1.1\" id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t\tviewBox=\"0 0 16.9 15\" style=\"enable-background:new 0 0 16.9 15;\" xml:space=\"preserve\">\n\t\t<polygon points=\"9,14.5 2,7.5 9,0.5 10.3,1.8 4.5,7.5 10.3,13.2 \"/>\n\t\t</svg>\n\t\t<p class=\"special-nav-home\">\n\t\tHome\n\t\t<p>\n\t</a>\n\t</div>\n\t<div class=\"special-nav-center\"> \n\t<a class = \"special-nav-logo-link\"\n\t\thref=\"/\"\n        target=\"_blank\"\n        rel=\"noopener noreferrer\">\n\t  <img\n\t  class=\"topper-special-nav-desk-logo\"\n\t  alt=\"Logo\"\n\t  src=\"https://files.sfchronicle.com/static-assets/logos/").concat(marketPrefix, "-white.png\"\n\t></img>\n\t</a>\n\t</div>\n\t<div class=\"special-nav-right\">\n\t").concat(navRightHtml, "\n\t</div>\n  </nav>");
  return navHTML;
};

module.exports = {
  getSpecialNav
};